var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiDropdown',{staticClass:"ListModeSwitch",attrs:{"items":_vm.items,"dropdownClasses":['ListModeSwitch__dropdown'],"label":"Zmień widok","placement":"down-end"},scopedSlots:_vm._u([{key:"trigger",fn:function(ref){
var toggle = ref.toggle;
return [_c('button',{staticClass:"ListModeSwitch__trigger",on:{"click":toggle}},[_c('UiIcon',{attrs:{"name":_vm.icon}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }